<script setup>
import Select2 from "@/components/Select2.vue";
import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const store = useStore();
const { t } = useI18n();

const selectedShop = computed({
  get: () => store.getters['shop/getCurrentShopId'] || '',
  set: (value) => {
    store.commit('shop/SET_CURRENT_SHOP', value, { root: true });
  }
});

const currentSociety = computed(() => store.getters['offices/getSelectedCompany']);
const currentSocietyId = computed(() => currentSociety.value?.id || null);

const shops = computed(() => store.getters['shop/getShops'] || [])

watch(
    () => currentSocietyId.value,
    () => {
      store.commit('shop/SET_CURRENT_SHOP', null);
      loadCompanyShops();
    },
    {immediate: true}
);

function loadCompanyShops() {
  if (currentSocietyId.value) {
    store.dispatch("shop/fetchShops", {society: currentSocietyId.value});
  }
}

onMounted(() => loadCompanyShops());
</script>

<template>
  <Select2
      container-class="w-250px"
      :multiple="false"
      :show-search="true"
      selectClass="form-control form-select form-select-solid rounded-end-0 border-start w-250px shadow-sm"
      name="office-selector"
      :placeholderText="$t('shop.sale.filter_by_all_shop')"
      :is-required="true"
      color="primary"
      clear
      v-model="selectedShop">
    <option v-for="shop in shops" :key="shop.id" :value="shop.id">
      {{ shop.name }}
    </option>
  </Select2>

</template>
